<template>
  <div class="page-content regPage">
    <div class="pageTitleBox d-flex d-flex-middle d-flex-between">
      <p class="pageTitle">考籍异动</p>
    </div>
    <div v-if="!infoChecked" class="profile-block-panel" v-loading="true"></div>
    <div v-else-if="!canAccessPage" class="profile-block-panel">
      <el-empty description="暂无法使用考籍异动功能">
        <p class="block-tip">您的证件正反面或手机号尚未完善，请先到左侧菜单「个人信息」页面维护完整后再使用本功能。</p>
        <el-button type="primary" @click="$router.push('/main/bmInfo')">前往完善个人信息</el-button>
      </el-empty>
    </div>
    <template v-else>
    <div class="tabs d-flex d-flex-middle d-flex-center">
      <p v-for="(e, i) in tabs" :key="i" @click="tabClick(i)" :class="{ 'on': activeTab === i }">
        {{ e }}
        <i :class="{ 'bgColor': activeTab === i }"></i>
      </p>
    </div>
    <!-- 退学申请 -->
    <div class="content status-apply-panel withdraw-tab" v-if="activeTab === 0" :key="'tab-withdraw'">
      <div class="section-block">
        <div class="section-head">考生基本信息</div>
        <div class="info-grid">
          <div class="info-item">
            <span class="label">姓名</span>
            <span class="value">{{ user.name || '—' }}</span>
          </div>
          <div class="info-item">
            <span class="label">准考证</span>
            <span class="value">{{ user.certiNo || '—' }}</span>
          </div>
          <div class="info-item">
            <span class="label">证件号码</span>
            <span class="value">{{ user.idCardNumber || '—' }}</span>
          </div>
          <div class="info-item">
            <span class="label">层次</span>
            <span class="value">{{ formatEduLevel(user.eduLevel) }}</span>
          </div>
          <div class="info-item">
            <span class="label">专业代码</span>
            <span class="value">{{ user.specialtyCode || '—' }}</span>
          </div>
          <div class="info-item">
            <span class="label">专业名称</span>
            <span class="value">{{ user.specialtyName || '—' }}</span>
          </div>
        </div>
        <el-form ref="formWithdraw" :model="form" label-width="120px" size="small" class="withdraw-form">
          <el-form-item label="退学原因" required>
            <el-input type="textarea" :rows="4" v-model="form.reason" placeholder="请输入退学原因" maxlength="500" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="电子签名">
            <el-image style="width: 150px; height: 100px" :src="form.filePath"
              v-if="form.filePath">
            </el-image>
            <p class="click color textBtn" @click="qrSign" v-else>点击扫码签名</p>
          </el-form-item>
        </el-form>
        <div class="submit-row">
          <p class="submit click" @click="subApply">提交</p>
        </div>
      </div>
      <el-divider></el-divider>
      <div class="section-head history-head">
        <span>历史申请记录</span>
        <span class="history-head-tip">申请提交成功后，请联系助学点审核。(助学点：{{studentInfo.helpCode+'-'+studentInfo.helpName}}{{ studentInfo.helpPhone ? '，联系方式:'+studentInfo.helpPhone : '' }})</span>
      </div>
      <el-table :data="tableData" style="width: 100%" border>
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column prop="createTime" label="申请时间" width="180"></el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template #default="{ row }">
            <span :class="['yd-status', ydStatusTone(row.status)]">{{ formatYdStatus(row.status) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="申请书" width="90" align="center">
          <template #default="{ row }">
            <a v-if="row.filePath" class="download-link" :href="row.filePath" target="_blank" rel="noopener noreferrer">下载</a>
            <span v-else class="muted">—</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="reason" label="退学原因" align="center"></el-table-column>
        <el-table-column label="审核意见" min-width="140">
          <template #default="{ row }">
            {{ majorAuditRemark(row) || '' }}
          </template>
        </el-table-column>
        <el-table-column prop="date" label="操作" width="100">
          <template #default="{ row }">
            <p class="click color textBtn" @click="annul(row)" v-if="row.status=='1'">撤销</p>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 转专业申请 -->
    <div class="content status-apply-panel major-transfer" v-else-if="activeTab === 1" :key="'tab-major'">
      <div class="section-block">
        <div class="section-head">考生基本信息</div>
        <div class="info-grid">
          <div class="info-item">
            <span class="label">姓名</span>
            <span class="value">{{ user.name || '—' }}</span>
          </div>
          <div class="info-item">
            <span class="label">准考证</span>
            <span class="value">{{ user.certiNo || '—' }}</span>
          </div>
          <div class="info-item">
            <span class="label">证件号码</span>
            <span class="value">{{ user.idCardNumber || '—' }}</span>
          </div>
          <div class="info-item">
            <span class="label">层次</span>
            <span class="value">{{ formatEduLevel(user.eduLevel) }}</span>
          </div>
          <div class="info-item">
            <span class="label">原专业代码</span>
            <span class="value">{{ user.specialtyCode || '—' }}</span>
          </div>
          <div class="info-item">
            <span class="label">原专业名称</span>
            <span class="value">{{ user.specialtyName || '—' }}</span>
          </div>
        </div>
        <el-form ref="formMajor" :model="formS" label-width="120px" size="small" class="major-form">
          <el-form-item label="拟毕业专业" required>
            <el-select
              v-model="formS.newSpecialtyId"
              placeholder="请选择拟毕业专业"
              class="full-w"
              filterable
              clearable
              @change="onMajorSpecialtyChange"
            >
              <el-option
                :label="formatSpecialtyLabel(e)"
                :value="e.id"
                v-for="(e, i) in majorSpList"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
          <div v-if="formS.newSpecialtyId && supplementDetail && supplementDetail.supplement" class="fee-calc-box" v-loading="supplementLoading">
            <div class="fee-calc-head">费用计算</div>
            <div class="fee-calc-grid">
              <div class="fee-calc-item">
                <span class="label">原专业费用标准</span>
                <span class="value">{{ formatMultiFeeStandard(supplementDetail, 'oldSpecialtyFee') }}</span>
              </div>
              <div class="fee-calc-item">
                <span class="label">转入专业费用标准</span>
                <span class="value">{{ formatMultiFeeStandard(supplementDetail, 'newSpecialtyFee') }}</span>
              </div>
              <div class="fee-calc-item">
                <span class="label">助学年限</span>
                <span class="value">{{ supplementDetail.year }}</span>
              </div>
              <div class="fee-calc-item">
                <span class="label">补缴金额</span>
                <span class="value fee-highlight">{{ formatSupplementAmount(supplementDetail && supplementDetail.supplement) }}</span>
              </div>
            </div>
          </div>
          <el-form-item label="申请原因" required>
            <el-input type="textarea" :rows="4" v-model="formS.reason" placeholder="请输入申请转专业的原因" maxlength="500" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="电子签名">
            <el-image style="width: 150px; height: 100px" :src="formS.filePath"
              v-if="formS.filePath">
            </el-image>
            <p class="click color textBtn" @click="qrSign" v-else>点击扫码签名</p>
          </el-form-item>
        </el-form>
        <div class="submit-row">
          <p class="submit click" @click="subApply">提交申请</p>
        </div>
      </div>
      <el-divider></el-divider>
      <div class="section-head history-head">
        <span>历史申请记录</span>
        <span class="history-head-tip">申请提交成功后，请联系助学点审核。(助学点：{{studentInfo.helpCode+'-'+studentInfo.helpName}}{{ studentInfo.helpPhone ? '，联系方式:'+studentInfo.helpPhone : '' }})</span>
      </div>
      <el-table :data="tableData" style="width: 100%" border>
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column prop="createTime" label="申请时间" width="170"></el-table-column>
        <el-table-column label="原专业" min-width="160" show-overflow-tooltip>
          <template #default="{ row }">
            {{ majorRowOldMajor(row) }}
          </template>
        </el-table-column>
        <el-table-column label="拟毕业专业" min-width="160" show-overflow-tooltip>
          <template #default="{ row }">
            {{ majorRowNewMajor(row) }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="130" align="center">
          <template #default="{ row }">
            <span :class="['yd-status', 'yd-status-tag', majorApplyStatusTone(row.status)]">{{ formatMajorApplyStatus(row.status) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="审核意见" min-width="140">
          <template #default="{ row }">
            {{ majorAuditRemark(row) || '' }}
          </template>
        </el-table-column>
        <el-table-column label="补缴金额" width="110" align="center">
          <template #default="{ row }">
            {{ row.supplementAmount || '0' }}
          </template>
        </el-table-column>
        <el-table-column label="缴费状态" width="110" align="center">
          <template #default="{ row }">
            <p
              v-if="row.supplementAmount"
              :class="['yd-status', 'yd-status-tag', supplementPayStatusTone(row.supplementStatus)]"
            >{{ majorRowSupplementPayStatus(row.supplementStatus) }}</p>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="申请书" width="90" align="center">
          <template #default="{ row }">
            <a v-if="row.filePath" class="download-link" :href="row.filePath" target="_blank" rel="noopener noreferrer">下载</a>
            <span v-else class="muted">—</span>
          </template>
        </el-table-column>
        <el-table-column prop="reason" label="申请原因" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template #default="{ row }">
            <el-button v-if="canRevokeMajor(row)" type="text" class="btn-revoke" @click="annul(row)">撤销</el-button>
            <span v-else class="muted"></span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    </template>
    <el-dialog title="请扫码签名" :visible.sync="dialogVisible" width="30%" :before-close="handleClose" :show-close="false"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <div style="text-align: center;padding: 15px;">
        <vue-qr :text="qrUrl" :margin="0"></vue-qr>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="signOk">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex"
import vueQr from "vue-qr";
import { edulevel, ydStatus, majorApplyStatus,supplementPayStatus } from "@/utils/enums";

export default {
  components: {
    vueQr,
  },
  data() {
    return {
      studentInfo:{},
      infoChecked: false,
      //tabs: ['退学申请', '转专业申请', '转助学点申请'],
      tabs: ['退学申请', '转专业申请'],
      activeTab: 0,
      form: {
        reason: "",
        filePath: '',
        type: '',
      },
      tableData: [],
      // 
      formS: {
        reason: "",
        filePath: '',
        type: '',
        specialtyId: '',
        newSpecialtyId: '',
      },
      qrUrl: '',
      dialogVisible: false,
      spList:[],
      supplementDetail: null,
      supplementLoading: false,
    };
  },
  computed: {
    ...mapState(['user']),
    canAccessPage() {
      return this.hasIdentityAndPhone();
    },
    majorSpList() {
      const currentId = this.user && this.user.specialtyId != null ? String(this.user.specialtyId) : ''
      return (this.spList || []).filter(item => String(item.id) !== currentId)
    },
    type: function () {
      let type = 3
      if (this.activeTab === 1) {
        type = 4
      } else if (this.activeTab === 0) {
        type = 3
      }
      this.form.type = type
      this.formS.type = type
      return type
    }
  },
  async mounted() {
    try {
      const res = await this.$http.get("/student/pc/getStudentInfo");
      this.studentInfo = res;
      this.$store.commit("LOGIN", { ...this.user, ...res });
    } catch (e) {
      // 拉取失败时保留已有 vuex 中的用户信息
    } finally {
      this.infoChecked = true;
      if (this.canAccessPage) {
        this.getData();
        this.getSpList();
      }
    }
  },
  methods: {
    hasIdentityAndPhone() {
      const u = this.user || {};
      const sfzAUrl = u.sfzAUrl != null ? String(u.sfzAUrl).trim() : "";
      const sfzBUrl = u.sfzBUrl != null ? String(u.sfzBUrl).trim() : "";
      const phone = u.phone != null ? String(u.phone).trim() : "";
      return !!(sfzAUrl && sfzBUrl && phone);
    },
    formatEduLevel(val) {
      if (val === undefined || val === null || val === "") return "—";
      const k = String(val);
      return edulevel[k] != null ? edulevel[k] : "—";
    },
    formatYdStatus(val) {
      if (val === undefined || val === null || val === "") return "";
      const k = String(val);
      return ydStatus[k] != null ? ydStatus[k] : val;
    },
    getSpList(){
      this.$http.get('/student/specialty/select',{isStop:'0'}).then(res=>{
        this.spList = res || []
      })
    },
    formatSpecialtyLabel(item) {
      if (!item) return '—'
      const code = item.code || item.specialtyCode || ''
      const name = item.name || item.specialtyName || ''
      if (code && name) return `${code}-${name}`
      return name || code || '—'
    },
    onMajorSpecialtyChange(val) {
      this.supplementDetail = null
      if (!val) return
      if (val === this.user.specialtyId) {
        this.$message.warning('新旧专业不能相同')
        this.formS.newSpecialtyId = ''
        return
      }
      this.fetchSupplementDetail()
    },
    fetchSupplementDetail() {
      const oldSpecialtyId = this.user.specialtyId
      const newSpecialtyId = this.formS.newSpecialtyId
      if (!oldSpecialtyId || !newSpecialtyId) return
      this.supplementLoading = true
      this.$http.get('/student/specialty/getSupplementDetail', {
        oldSpecialtyId,
        newSpecialtyId,
      }).then(res => {
        this.supplementDetail = res || null
      }).catch(() => {
        this.supplementDetail = null
      }).finally(() => {
        this.supplementLoading = false
      })
    },
    formatMoney(val, unit) {
      if (val === undefined || val === null || val === '') return '0'
      const num = Number(val)
      if (Number.isNaN(num)) return String(val)
      return `${num.toLocaleString('zh-CN')} ${unit}`
    },
    formatFeeStandard(val) {
      return this.formatMoney(val, '元/年')
    },
    formatMultiFeeStandard(detail, keyPrefix) {
      if (!detail) return '—'
      const values = [1, 2, 3]
        .map(i => detail[`${keyPrefix}${i}`])
        .filter(v => v !== undefined && v !== null && v !== '')
      if (!values.length) return '—'
      return values.map(v => this.formatFeeStandard(v)).join('，')
    },
    formatSupplementAmount(val) {
      return this.formatMoney(val, '元')
    },
    formatMajorApplyStatus(val) {
      if (val === undefined || val === null || val === '') return '—'
      const k = String(val)
      return majorApplyStatus[k] != null ? majorApplyStatus[k] : this.formatYdStatus(val)
    },
    majorApplyStatusTone(status) {
      const s = Number(status)
      if (s === 1 || s === 2) return 'is-pending'
      if (s === 3) return 'is-pass'
      if (s === -2 || s === 5) return 'is-refund'
      if (s === -1 || s === 0) return 'is-reject'
      return 'is-neutral'
    },
    supplementPayStatusTone(status) {
      const s = Number(status)
      if (s === 0) return 'is-pending'
      if (s === 1) return 'is-pass'
      if (s === 2) return 'is-refund'
      return 'is-neutral'
    },
    async getData() {
      this.tableData = []
      this.$http.get('/student/pc/studentStatus/list', { type: this.type }).then(res => {
        this.tableData = res
      })
    },
    tabClick(index) {
      this.activeTab = Number(index)
      this.$nextTick(() => {
        this.getData()
      })
    },
    handleClose() {
      this.dialogVisible = false
    },
    signOk() {
      this.$http.post('/student/pc/studentStatus/qrCode/complete', { id: this.user.id, type: this.type }).then(async (res) => {
        if (this.type == 3) {
          this.form.filePath = res
        } else if (this.type == 4){
          this.formS.filePath = res
        }
        this.handleClose()
      })
    },
    qrSign() {
      this.qrUrl = location.href.replace('/main/register','/sign') + '?id=' + this.user.id + '&type=' + this.type
      this.dialogVisible = true
    },
    subApply() {
      if (!this.hasIdentityAndPhone()) {
        this.$message.error(
          "请先在「个人信息」中完善身份证正反面与手机号后再提交申请。"
        );
        return;
      }
      let params = {}
      if (this.type == 3) {
        params=this.form
      } else if (this.type == 4){
        params=this.formS
      }
      if (!params.reason) {
        this.$message.error(this.type == 4 ? '申请原因不能为空！' : '退学原因不能为空！')
        return
      }
      if (!params.filePath && (this.type == 3 || this.type == 4)) {
        this.$message.error('电子签名不能为空！')
        return
      }
      if (!params.newSpecialtyId&&this.type==4) {
        this.$message.error('请选择拟毕业专业！')
        return
      }
      if(this.type==4){
        params.specialtyId = this.user.specialtyId
        if(params.specialtyId==params.newSpecialtyId){
          this.$message.error('新旧专业不能相同！')
          return
        }
      }
   
      const _this = this
      _this.$http.post('/student/pc/studentStatus/apply', params).then(res => {
        _this.$message.success('操作成功！')
        _this.clearFrom()
        _this.getData()
      })
    },
    clearFrom() {
      this.form = {
        reason: "",
        filePath: '',
        type: '',
      }
      this.formS = {
        reason: "",
        filePath: '',
        type: '',
        specialtyId: '',
        newSpecialtyId: '',
      }
      this.supplementDetail = null
    },
    annul(e) {
      const _this = this
      this.$confirm('确定撤销该申请, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$http.post('/student/pc/studentStatus/annul/'+e.id).then(res => {
          _this.getData()
        })
      }).catch(() => {

      });
    },
    parseRowData(data) {
      if (data == null || data === '') return null
      try {
        return typeof data === 'string' ? JSON.parse(data) : data
      } catch (e) {
        return null
      }
    },
    majorRowOldMajor(row) {
      const d = this.parseRowData(row.data)
      if (!d) return '—'
      const code = d.specialtyCode
      const name = d.specialtyName
      if (code && name) return `${code} ${name}`
      return name || code || '—'
    },
    majorRowNewMajor(row) {
      const d = this.parseRowData(row.data)
      if (!d) return '—'
      const code = d.newSpecialtyCode
      const name = d.newSpecialtyName
      if (code && name) return `${code} ${name}`
      return name || code || '—'
    },
    majorRowSupplementPayStatus(status) {
      return supplementPayStatus[status] || '—'
    },
    ydStatusTone(status) {
      const s = Number(status)
      if (s === 1 || s === 2) return 'is-pending'
      if (s === 3) return 'is-pass'
      if (s === -1 || s === 0) return 'is-reject'
      if (s === 4) return 'is-refund'
      return 'is-neutral'
    },
    majorAuditRemark(row) {
      const t = row.lastCheckRemark || row.checkRemark
      return (t && String(t).trim()) ? t : ''
    },
    canRevokeMajor(row) {
      const s = Number(row.status)
      return s === 1
    },
    toItem(data,item){
      const d = this.parseRowData(data)
      if (d && item in d) return d[item]
      return ''
    }

  },
};
</script>
<style>
.el-tooltip__popper {
  max-width: 500px !important; 
  text-align: center; 
  max-height: 400px; 
  overflow: auto; 
  font-size: 14px; 
  }
</style>
<style lang="scss" scoped>
@import "@/variable.scss";
.regPage {
  
  .pageTitleBox {
    height: 80px;
    box-sizing: border-box;
    padding: 0 30px;

    .pageTitle {
      font-weight: bold;
      font-size: 18px;
      color: #333;
    }

    .mb0 {
      margin-bottom: 0;
    }
  }

  .tabs {
    width: 100%;
    height: 40px;
    background: rgb(233, 239, 249);

    p {
      width: 100px;
      text-align: center;
      margin: 0 30px;
      font-size: 16px;
      cursor: pointer;
      line-height: 40px;
      position: relative;
      color: rgb(51, 51, 51);
    }

    i {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 20px;
      height: 4px;
      background-color: transparent;
      background: transparent;
    }

    .on {
      color: $primary;
    }

    .bgColor {
      background: $primary;
    }
  }

  .content {
    width: 90%;
    margin: 30px auto;

    .textBtn {
      display: inline-block;
    }

    .submit {
      width: 160px;
      height: 36px;
      line-height: 36px;
      background: #0065BA;
      color: #fff;
      border-radius: 20px;
      margin: 50px auto;
      text-align: center;
    }
  }
}

.el-image {
  border: 1px solid #ccc;
}

.regPage .status-apply-panel {
  .section-head {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 20px;

    &.history-head {
      margin-top: 4px;
      margin-bottom: 16px;
    }
  }

  .info-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px 40px;
    margin-bottom: 24px;
    padding-bottom: 24px;
    border-bottom: 1px solid #f0f0f0;

    .info-item {
      display: flex;
      align-items: flex-start;
      font-size: 14px;
      line-height: 1.6;

      .label {
        color: #767676;
        margin-right: 8px;
        flex-shrink: 0;

        &::after {
          content: '：';
        }
      }

      .value {
        color: #303133;
        word-break: break-all;
        flex: 1;
      }
    }
  }

  .withdraw-form {
    max-width: 100%;

    ::v-deep .el-form-item__label {
      font-weight: 500;
    }
  }

  .submit-row {
    display: flex;
    justify-content: center;

    .submit {
      margin: 16px 0 0;
    }
  }
}

.regPage .major-transfer {
  .major-form {
    max-width: 100%;

    ::v-deep .el-form-item__label {
      font-weight: 500;
    }
  }

  .fee-calc-box {
    margin: 0 0 18px 120px;
    padding: 16px 20px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    background: #fafafa;
    min-height: 80px;

    .fee-calc-head {
      font-size: 14px;
      font-weight: 600;
      color: #303133;
      margin-bottom: 14px;
    }

    .fee-calc-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 12px 40px;
    }

    .fee-calc-item {
      display: flex;
      align-items: center;
      font-size: 14px;
      line-height: 1.6;

      .label {
        color: #767676;
        margin-right: 8px;
        flex-shrink: 0;

        &::after {
          content: '：';
        }
      }

      .value {
        color: #303133;

        &.fee-highlight {
          color: #303133;
          font-weight: 600;
        }
      }
    }
  }

  .full-w {
    width: 100%;
  }

  .download-link {
    color: $primary;

    &:hover {
      text-decoration: underline;
    }
  }

  .muted {
    color: #c0c4cc;
  }

  .btn-revoke {
    color: $danger !important;
    font-weight: 500;
  }
}
.yd-status {
    &.is-pending {
      color: $warning;
    }

    &.is-pass {
      color: $success;
    }

    &.is-reject {
      color: $danger;
    }

    &.is-refund {
      color: $info;
    }

    &.is-neutral {
      color: #303133;
    }

    &.yd-status-tag {
      display: inline-block;
      padding: 2px 10px;
      border-radius: 4px;
      font-size: 12px;
      line-height: 20px;

      &.is-pending {
        color: #e6a23c;
        background: #fdf6ec;
      }

      &.is-pass {
        color: #67c23a;
        background: #f0f9eb;
      }

      &.is-reject {
        color: #f56c6c;
        background: #fef0f0;
      }

      &.is-refund {
        color: #909399;
        background: #f4f4f5;
      }

      &.is-neutral {
        color: #606266;
        background: #f4f4f5;
      }
    }
  }
  .history-head-tip {
    font-size: 14px;
    color: #ee4545;
    margin-left: 20px;
    font-weight: 400;
  }

  .profile-block-panel {
    min-height: 360px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;

    .block-tip {
      max-width: 480px;
      margin: 0 0 20px;
      font-size: 14px;
      line-height: 1.6;
      color: #606266;
      text-align: center;
    }
  }
</style>
